import React from 'react';
import Icon from './Icon';

// Generated backdrops that stand in for the reference's photographic heroes.
function Circuit() {
  const dots = [[8, 20], [22, 70], [38, 35], [55, 82], [70, 28], [86, 62], [94, 18], [14, 90], [48, 12]];
  return (
    <svg className="phero__art" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <g stroke="#80c342" strokeOpacity=".28" strokeWidth=".25" fill="none">
        <path d="M0 20h22l8 15h20M0 70h18l10 12h30M40 0v35M62 100V70h38M75 28h25M100 62H70l-8-8" />
        <path d="M8 20v50M86 62V28" strokeOpacity=".15" />
      </g>
      <g fill="#80c342" fillOpacity=".55">{dots.map(([x, y]) => <circle key={`${x}${y}`} cx={x} cy={y} r=".7" />)}</g>
      <g fill="#fff" fillOpacity=".12" fontSize="4" fontFamily="monospace">
        <text x="6" y="45">0101</text><text x="68" y="12">00 011</text><text x="40" y="94">1 1</text><text x="82" y="88">0101</text>
      </g>
    </svg>
  );
}

function Mosaic() {
  return (
    <div className="phero__mosaic" aria-hidden="true">
      {Array.from({ length: 8 }).map((_, i) => (
        <span key={i} className={`tile tile--${i % 4}`}><i /><i /><i /></span>
      ))}
    </div>
  );
}

// Inner-page hero: dark gradient, left-aligned (or centred) title, text and optional pill buttons.
export default function PageHero({ title, text, primary, secondary, center = false, art }) {
  return (
    <section className={`phero ${center ? 'phero--center' : ''}`}>
      <div className="hero__grid-bg" />
      {art === 'circuit' && <Circuit />}
      {art === 'mosaic' && <Mosaic />}
      {!art && <div className="phero__glow" />}
      <div className="container phero__inner">
        <h1>{title}</h1>
        {text && <p>{text}</p>}
        {(primary || secondary) && (
          <div className="hero__actions">
            {primary && (
              <button className={`btn ${primary.glass ? 'btn--glass' : 'btn--primary'}`} onClick={primary.onClick}>
                {primary.label} <Icon name="arrow" size={18} />
              </button>
            )}
            {secondary && (
              <button className="btn btn--ghost" onClick={secondary.onClick}>{secondary.label}</button>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
